/* eslint-disable max-len */
import React from 'react';

const EmailActive: React.FC = () => {
    return (
        <svg
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M12.25 11.8337C13.2164 11.8335 14 11.0501 14 10.0837V3.5861L8.17806 7.33333C8.16968 7.33872 8.1605 7.34434 8.15186 7.34928C7.8043 7.54787 7.40286 7.65006 6.99886 7.65006C6.64549 7.64994 6.29407 7.57253 5.97917 7.41992L5.84587 7.34928C5.83721 7.34432 5.82804 7.33873 5.81966 7.33333L0 3.58724V10.0837C0 11.0502 0.783502 11.8337 1.75 11.8337H12.25ZM14 2.35107V1.91699C14 0.950578 13.2164 0.167129 12.25 0.166992H1.75C0.783502 0.166992 0 0.950494 0 1.91699V2.34766C0.0886685 2.33909 0.179434 2.35076 0.265462 2.38411L0.37028 2.43766L6.43148 6.3387C6.59378 6.43021 6.79116 6.48325 6.99886 6.4834C7.20639 6.4834 7.40394 6.42994 7.56624 6.3387L13.6286 2.4388C13.7432 2.36514 13.8742 2.33877 14 2.35107Z"
                fill="#616E6E"
            />
        </svg>
    );
};

export default EmailActive;